import { AxiosRequestConfig, AxiosResponse, AxiosError, AxiosInstance, CancelToken } from 'axios';

export function wait(time: number) {
  return new Promise(resolve => {
    setTimeout(resolve, time);
  });
}

// 返回唯一的请求key
export function getRequestKey(config: AxiosRequestConfig) {
  const { method, url, params, data } = config;
  return [method, url, JSON.stringify(params), JSON.stringify(data)].join('&');
}
